import React from 'react';
import { WideAlert, Icons } from '@components';
import { mdiCommentAlertOutline } from '@mdi/js';

export const AlertaProcessoSolicitacao = () => {
  return (
    <div className="mx-4">
      <WideAlert iconClear={false}>
        <div className="d-block d-lg-flex align-items-center">
          <Icons
            path={mdiCommentAlertOutline}
            color="var(--primary-color)"
            size={2}
            style={{ marginRight: 4 }}
          />
          <p className="ts-24">
            <strong>Aviso importante:</strong> <br />
            <br />A partir dessa etapa você está entrando no processo de
            solicitação da sua opção.
            <br />
            <br /> Leia os termos com atenção antes de solicitar a transformação
            clicando em &#34;
            <span className="text-orange fw-bold">Próximo</span>&#34;.
          </p>
        </div>
      </WideAlert>
    </div>
  );
};
